import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from "react-select";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import { PAYMENT_TYPE } from "../../../../state/helpers/Payment";
class PaymentSectionContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
            forceSaveCard: content.forceSaveCard || false,
            forceSaveBankAccount : content.forceSaveBankAccount || false,
            payDepositButtonText: content.payDepositButtonText || '',
            payBalanceButtonText: content.payBalanceButtonText || '',
            allowPartialPayment: content.allowPartialPayment || false,
            defaultPaymentMethod: content.defaultPaymentMethod || 'credit-card',
            paymentMethods: content.paymentMethods || GlobalHelper.getPaymentMethods(),
            paymentMethodOptions: GlobalHelper.getPaymentMethodOptions(),
            hideAdditionalFeesMayApplyMessage: content.hideAdditionalFeesMayApplyMessage || false,
            acceptedCardBrands: content.acceptedCardBrands || [],
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handlePaymentMethods = this.handlePaymentMethods.bind(this)
        this.handleDefaultPaymentMethod = this.handleDefaultPaymentMethod.bind(this)
        this.handleAcceptedCardBrands = this.handleAcceptedCardBrands.bind(this)
        this.paymentMethodIsSelected = this.paymentMethodIsSelected.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            forceSaveCard: this.state.forceSaveCard,
            forceSaveBankAccount : this.state.forceSaveBankAccount,
            payDepositButtonText: this.state.payDepositButtonText,
            payBalanceButtonText: this.state.payBalanceButtonText,
            allowPartialPayment: this.state.allowPartialPayment,
            paymentMethods: this.state.paymentMethods,
            acceptedCardBrands: this.state.acceptedCardBrands,
            defaultPaymentMethod: this.state.defaultPaymentMethod,
            hideAdditionalFeesMayApplyMessage: this.state.hideAdditionalFeesMayApplyMessage || false
        })
    }

    componentDidMount() {
        this.triggerChanged()

        if (this.state.variables && this.state.variables.quote) {
            this.setState({
                paymentMethodOptions: this.state.paymentMethodOptions.concat(
                    GlobalHelper.getAllStripeIntegrationsPaymentMethodOptions()
                )
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            forceSaveCard: content.forceSaveCard || false,
            forceSaveBankAccount : content.forceSaveBankAccount || false,
            payDepositButtonText: content.payDepositButtonText || '',
            payBalanceButtonText: content.payBalanceButtonText || '',
            allowPartialPayment: content.allowPartialPayment || '',
            variables: nextProps.variables || {},
            defaultPaymentMethod: content.defaultPaymentMethod || 'credit-card',
            paymentMethods: content.paymentMethods || ['credit-card', 'bank-transfer'],
            acceptedCardBrands: content.acceptedCardBrands || [],
            hideAdditionalFeesMayApplyMessage: content.hideAdditionalFeesMayApplyMessage || false
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handlePaymentMethods(paymentMethods) {
        if (paymentMethods.length === 0) {
            paymentMethods = [{ value: 'credit-card' }]
        }
        let state = {
            paymentMethods: paymentMethods.map(option => {
                return option.value
            })
        }
        if (paymentMethods.length === 1) {
            state.defaultPaymentMethod = paymentMethods[0].value
        }

        this.setState(state, this.triggerChanged)
    }

    handleDefaultPaymentMethod(paymentMethod) {
        this.setState({
            defaultPaymentMethod: paymentMethod.value,
        }, this.triggerChanged)
    }

    handleAcceptedCardBrands(acceptedCardBrands) {
        this.setState({
            acceptedCardBrands: acceptedCardBrands.map(option => option.value)
        }, this.triggerChanged)
    }

    paymentMethodIsSelected(paymentMethod) {
        return this.state.paymentMethods.includes(paymentMethod)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="payDepositButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.payment_section.pay_deposit_button_label"
                            defaultMessage="Pay deposit button text"
                        />
                    </label>
                    <div className="col-9">
                        <input
                            name="payDepositButtonText"
                            value={this.state.payDepositButtonText}
                            onChange={this.handleFormChange}
                            id="payDepositButtonText"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage({ id: 'payment.pay_deposit_btn' })}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.pay_deposit_button_description"
                                defaultMessage="This text will replace the pay deposit button text"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.payment_section.pay_balance_button_label"
                            defaultMessage="Pay deposit button text"
                        />
                    </label>
                    <div className="col-9">
                        <input
                            name="payBalanceButtonText"
                            value={this.state.payBalanceButtonText}
                            onChange={this.handleFormChange}
                            id="payBalanceButtonText"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage({ id: 'payment.pay_btn' })}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.pay_balance_button_description"
                                defaultMessage="This text will replace the pay now button text"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.payment_section.payment_methods_label"
                            defaultMessage="Payment methods"
                        />
                    </label>
                    <div className="col-9">
                        <Select
                            searchable={false}
                            multi
                            value={this.state.paymentMethods}
                            onChange={this.handlePaymentMethods}
                            options={this.state.paymentMethodOptions}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.payment_methods_description"
                                defaultMessage="This is the list of payment methods your customer will be able to pay from."
                            />
                        </small>
                    </div>
                </div>
                {this.state.paymentMethods.length > 1 && <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.payment_section.default_payment_method_label"
                            defaultMessage="Default payment method"
                        />
                    </label>
                    <div className="col-9">
                        <Select
                            searchable={false}
                            clearable={false}
                            value={this.state.defaultPaymentMethod}
                            onChange={this.handleDefaultPaymentMethod}
                            options={this.state.paymentMethodOptions}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.default_payment_method_description"
                                defaultMessage="This will open the selected tab by default."
                            />
                        </small>
                    </div>
                </div>}
                {this.paymentMethodIsSelected(PAYMENT_TYPE.CREDIT_CARD) && (
                    <>
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="acceptedCardBrands">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.accepted_card_brands"
                                    defaultMessage="Accepted Card Brands"
                                />
                            </label>
                            <div className="col-9">
                                <Select
                                    name="acceptedCardBrands"
                                    searchable={false}
                                    multi
                                    value={this.state.acceptedCardBrands}
                                    onChange={this.handleAcceptedCardBrands}
                                    options={GlobalHelper.getCardBrandOptions()}
                                    placeholder={this.props.intl.formatMessage({
                                        id: 'templates.sections.form.edit.content.payment_section.card_brands_placeholder',
                                        defaultMessage: 'All'
                                    })}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.payment_section.card_brands_description"
                                        defaultMessage="This is the list of card brands your customer will be able to use for payment."
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3" />
                            <div className="col-9">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="forceSaveCard"
                                        name="forceSaveCard"
                                        value={this.state.forceSaveCard}
                                        checked={this.state.forceSaveCard}
                                        onChange={this.handleFormChange}
                                    />
                                    <label className="custom-control-label" htmlFor="forceSaveCard">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.force_save_card_label"
                                            defaultMessage="Save card on file for all payments"
                                        />
                                    </label>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.force_save_card_description"
                                            defaultMessage="This will hide the save card checkbox and will save the card on file automatically."
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {this.paymentMethodIsSelected(PAYMENT_TYPE.BANK_TRANSFER) && <div className="row">
                    <div className="col-3" />
                    <div className="col-9">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="forceSaveBankAccount"
                                name="forceSaveBankAccount"
                                value={this.state.forceSaveBankAccount}
                                checked={this.state.forceSaveBankAccount}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="forceSaveBankAccount">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_bank_account_label"
                                    defaultMessage="Save bank account on file for all payments"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_bank_account_description"
                                    defaultMessage="This will hide the save bank account checkbox and will save the bank account on file automatically."
                                />
                            </small>
                        </div>
                    </div>
                </div>}
                {
                    !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                     <>
                        <div className="row">
                            <div className="col-2" />
                            <div className="col-10">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="allowPartialPayment"
                                        name="allowPartialPayment"
                                        value={this.state.allowPartialPayment}
                                        checked={this.state.allowPartialPayment}
                                        onChange={this.handleFormChange}
                                    />
                                    <label className="custom-control-label" htmlFor="allowPartialPayment">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.allow_partial_payment_label"
                                            defaultMessage="Allow to edit payment amount for partial payment"
                                        />
                                    </label>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.allow_partial_payment_description"
                                            defaultMessage="This will allow your customer to partially pay the balance by inputting an amount."
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>

                         <div className="row">
                             <div className="col-2" />
                             <div className="col-10">
                                 <div className="custom-control custom-checkbox">
                                     <input
                                         className="custom-control-input"
                                         type="checkbox"
                                         id="hideAdditionalFeesMayApplyMessage"
                                         name="hideAdditionalFeesMayApplyMessage"
                                         value={this.state.hideAdditionalFeesMayApplyMessage}
                                         checked={this.state.hideAdditionalFeesMayApplyMessage}
                                         onChange={this.handleFormChange}
                                     />
                                     <label className="custom-control-label" htmlFor="hideAdditionalFeesMayApplyMessage">
                                         <FormattedMessage
                                             id="templates.sections.form.edit.content.payment_section.hide_additional_fees_text"
                                             defaultMessage="Hide additional fees may apply message"
                                         />
                                     </label>
                                     <small className="form-text text-muted">
                                         <FormattedMessage
                                             id="templates.sections.form.edit.content.payment_section.hide_additional_fees_text_description"
                                             defaultMessage="This will hide the message that additional fees may apply at checkout"
                                         />
                                     </small>
                                 </div>
                             </div>
                         </div>
                    </>
                }
            </div>
        );
    }
}

export default injectIntl(PaymentSectionContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/payment/input.component.jsx